import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import {
  selectEndDate,
  selectStartDate,
  downloadShopTimeTrackReportCsv,
  downloadBrandTimeTrackReportCsv,
} from '../../actions';
import TimeTrackingFilter from './TimeTrackingFilter';
import { canLoadReport, getDateRange } from '../../selectors';
import { getActiveType, getActiveShopId, getActiveBrandId } from '../../../../auth/selectors';
import withTimezone from '../../../../auth/utils/withTimezone';
import { ChurnZeroService, RUN_TIME_TRACKING_REPORT } from '../../../../../modules/infra/observability/churnzero';

const mapStateToProps = state => ({
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  activeType: getActiveType(state),
  shopId: getActiveShopId(state),
  brandId: getActiveBrandId(state),
  canInstantDownloadCsv: canLoadReport(state),
  timezone: state.auth.timezone,
});

const mapDispatchToProps = {
  selectStartDate,
  selectEndDate,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onDateChange: props => (from, to) => {
      props.selectStartDate(from);
      props.selectEndDate(to);
    },
    downloadCsv: props => () => {
      ChurnZeroService.track(RUN_TIME_TRACKING_REPORT);
      const { start, end } = getDateRange(props);
      if (props.activeType === 'shop') {
        return downloadShopTimeTrackReportCsv(
          props.shopId,
          start.toJSON(),
          end.toJSON(),
          props.timezone,
        );
      } else if (props.activeType === 'brand') {
        return downloadBrandTimeTrackReportCsv(
          props.brandId,
          start.toJSON(),
          end.toJSON(),
          props.timezone,
        );
      }
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      let from = null;
      let to = null;
      if (prevProps.startDate !== this.props.startDate) {
        from = this.props.startDate;
      }

      if (prevProps.endDate !== this.props.endDate) {
        to = this.props.endDate;
      }

      if (from || to) {
        this.props.onDateChange(from || this.props.startDate, to || this.props.endDate);
      }
    },
  }),
  withTimezone,
)(TimeTrackingFilter);
